import { getEmbedUrlByPostID } from '@common/utils/embeds';
import { Iframe } from '@web/atoms/Iframe';

interface Props {
    postID: string;
}

export const TikTokVideo = ({ postID }: Props) => {
    const embedUrl = getEmbedUrlByPostID('tiktok', postID);

    if (!embedUrl) {
        return null;
    }

    return <Iframe src={embedUrl} />;
};
